export enum CAROUSEL_TYPES {
    PRODUCTS,
    WIDGETS,
}

export const DEFAULT_CHILD_WIDTH_RATIO = 36;

export const HEIGHT_BUFFERS = {
    BASE: 10,
    TITLE: 24,
    DESCRIPTION: 20,
};
